// React
import React from 'react';
// External libraries
import { Form, Button, Alert } from 'react-bootstrap';
import { Link } from 'react-router-dom';
// Internal
import { sendResetPassword } from 'services/users';
import getFormFieldVal from 'utils/getFormFieldVal';

class ForgotPassword extends React.Component {
    constructor(props) {
        super(props);
        const email = new URLSearchParams(window.location.search).get('email');
        this.state = {
            cognitoError: '',
            email: '',
            errors: [],
            success: false
        };

        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleInputChange(event) {
        const fieldObj = getFormFieldVal(event);
        this.setState((prevState) => {
            if (prevState.errors.length) {
                const { errors } = prevState;
                const errorIndex = errors.indexOf(event.target.name);
                if (errorIndex >= 0) {
                    errors.splice(errorIndex, 1);
                }
                return { ...fieldObj, errors };
            }
            return { ...fieldObj };
        });
    }

    handleSubmit(event) {
        event.preventDefault();
        const errorList = [];
        /**
         * @todo check validation for email? or send with username?
         */
        // const expression = /\S+@\S+/;
        // const validEmail = expression.test(String(this.state.email).toLowerCase());
        // if (!validEmail) errorList.push('email');
        if (!this.state.email) errorList.push('email');

        this.setState({ errors: errorList });
        if (errorList.length > 0) return false;

        /**
         * Requests the reset password
         */
        sendResetPassword(this.state.email)
            .then(() => {
                // Response handler
                this.props.onSubmit(this.state.email);
            })
            .catch((err) => {
                if (err.code === "LimitExceededException") {
                    this.setState({ cognitoError: err.message, errors: ['email'] });
                }
                // Error handler
            });
    }

    hasError(key) {
        return this.state.errors.indexOf(key) !== -1;
    }

    render() {
        return (
            <div>
                <Form>
                    <Form.Group controlId="email" className="control-group control-email">
                        <Form.Label>Username</Form.Label>
                        <Form.Control
                            className={
                                this.hasError('email')
                                    ? 'form-control input-field input-email is-invalid'
                                    : 'form-control input-field input-email'
                            }
                            name="email"
                            onChange={this.handleInputChange}
                            type="text"
                            placeholder="Enter email"
                        />
                        <Form.Control.Feedback
                            type="invalid"
                            className={
                                this.hasError('email') ? 'invalid-feedback' : 'hidden'
                            }
                        >
                            {this.state.cognitoError ? this.state.cognitoError : 'Email is invalid or not registered'}
                        </Form.Control.Feedback>
                    </Form.Group>

                    {this.state.success === true
                        ? (
                            <Alert variant="success" className="alert-success-send-email">
                                {`Email sent to ${this.state.email}'s email address, please check your inbox for reset password link.`}
                            </Alert>
                        ) : '' }
                    <Button className="login-button" onClick={this.handleSubmit} type="submit">
                        Submit
                    </Button>
                </Form>
                <div className="link-wrapper">
                    <Link
                        className="link"
                        to={{
                            pathname: '/login',
                            search: this.state.email ? `?email=${this.state.email}` : null
                        }}
                    >
                        Return to login
                    </Link>
                </div>
            </div>
        );
    }
}

export default ForgotPassword;
